export const TEAM_NAMES: Record<string, string> = {
  ARI: 'Arizona Cardinals', ATL: 'Atlanta Falcons', BAL: 'Baltimore Ravens', BUF: 'Buffalo Bills',
  CAR: 'Carolina Panthers', CHI: 'Chicago Bears', CIN: 'Cincinnati Bengals', CLE: 'Cleveland Browns',
  DAL: 'Dallas Cowboys', DEN: 'Denver Broncos', DET: 'Detroit Lions', GB: 'Green Bay Packers',
  HOU: 'Houston Texans', IND: 'Indianapolis Colts', JAX: 'Jacksonville Jaguars', KC: 'Kansas City Chiefs',
  LAC: 'Los Angeles Chargers', LAR: 'Los Angeles Rams', LV: 'Las Vegas Raiders', MIA: 'Miami Dolphins',
  MIN: 'Minnesota Vikings', NE: 'New England Patriots', NO: 'New Orleans Saints', NYG: 'New York Giants',
  NYJ: 'New York Jets', PHI: 'Philadelphia Eagles', PIT: 'Pittsburgh Steelers', SEA: 'Seattle Seahawks',
  SF: 'San Francisco 49ers', TB: 'Tampa Bay Buccaneers', TEN: 'Tennessee Titans', WAS: 'Washington Commanders'
};

export function normalizeText(s: string): string {
  return (s || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s/]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function teamAliases(abbrev?: string): string[] {
  if (!abbrev) return [];
  const full = TEAM_NAMES[abbrev] || '';
  if (!full) return [abbrev];
  const parts = full.split(' ');
  const city = parts.slice(0, parts.length - 1).join(' ');
  const nickname = parts[parts.length - 1];
  const aliases = [abbrev, full, city, nickname];
  // Special cases
  if (abbrev === 'SF') aliases.push('49ers', 'niners');
  if (abbrev === 'TB') aliases.push('bucs', 'buccaneers');
  if (abbrev === 'LAR') aliases.push('rams');
  if (abbrev === 'LAC') aliases.push('chargers');
  if (abbrev === 'LV') aliases.push('raiders');
  if (abbrev === 'JAX') aliases.push('jacksonville');
  if (abbrev === 'WAS') aliases.push('washington');
  return aliases.map(normalizeText);
}

export function displayDstName(teamAbbrev?: string): string {
  const full = TEAM_NAMES[teamAbbrev || ''] || (teamAbbrev || '');
  return `${full} D/ST`;
}


